import { motion } from 'motion/react';

interface FilterSwitchProps {
  enabled: boolean;
  onToggle: () => void;
  label: string;
  description?: string;
}

export function FilterSwitch({
  enabled,
  onToggle,
  label,
  description,
}: FilterSwitchProps) {
  // Dimensões alinhadas com o design
  const trackW = 50;
  const trackH = 32;
  const pad = 3; // padding interno do track
  const thumbSize = trackH - pad * 2; // 26
  const travel = trackW - pad * 2 - thumbSize; // distância que a bolinha percorre

  return (
    <button
      onClick={onToggle}
      className="w-full flex items-center justify-between gap-4 transition-opacity"
      style={{
        cursor: 'pointer',
        border: 'none',
        background: 'transparent',
        paddingTop: '12px',
        paddingBottom: '12px',
        paddingLeft: '0px',
        paddingRight: '0px',
      }}
      type="button"
    >
      {/* Left side - Label and Description */}
      <div className="flex-1 text-left min-w-0">
        <div
          style={{
            fontSize: 'var(--text-base)',
            fontWeight: 'var(--font-weight-medium)',
            lineHeight: '1.5',
            color: 'var(--foreground)',
            marginBottom: description ? '2px' : '0',
          }}
        >
          {label}
        </div>
        {description && (
          <div
            style={{
              fontSize: 'var(--text-sm)',
              lineHeight: '1.4',
              color: 'var(--muted-foreground)',
              opacity: 0.8,
            }}
          >
            {description}
          </div>
        )}
      </div>

      {/* Right side - Switch */}
      <div className="flex-shrink-0">
        <motion.div
          className="relative inline-block"
          style={{
            width: '44px',
            height: '26px',
            borderRadius: '13px',
            backgroundColor: enabled
              ? 'var(--kojo-blue)'
              : 'var(--switch-background)',
            cursor: 'pointer',
            transition: 'background-color 0.2s ease',
            flexShrink: 0,
          }}
          whileTap={{ scale: 0.96 }}
        >
          <motion.div
            className="absolute"
            style={{
              top: '3px',
              width: '20px',
              height: '20px',
              borderRadius: '50%',
              backgroundColor: 'white',
              marginTop: 3,
              marginInline: 3,
              boxShadow: '0 2px 4px rgba(0, 0, 0, 0.15)',
            }}
            initial={false}
            animate={{ x: enabled ? travel : 0 }}
            transition={{ type: 'spring', stiffness: 700, damping: 35 }}
          />
        </motion.div>
      </div>
    </button>
  );
}
